
  <ng-container *ngIf="formGroup">
    <form [formGroup]="formGroup" (ngSubmit)="onSave()">
      <div class="section-title">{{ settingsConfiguration.header }}</div>
      <div class="py-4">
        <div>
          {{ settingsConfiguration.instructions }}
        </div>
        <div class="h-4">
          <mat-error *ngIf="formGroup.hasError('pin-mismatch')"
            >The entered PIN does not match with the Confirm PIN. Please try
            again.</mat-error
          >
        </div>
        <div class="flex pt-2 gap-4">
          <app-input
            [required]="true"
            formControlName="pin"
            [maxLength]="6"
            placeholder="Enter PIN"
            [possibleErrors]="pinErrors"
          ></app-input>
          <app-input
            [required]="true"
            [maxLength]="6"
            formControlName="pinConfirmation"
            placeholder="Confirm PIN"
            [possibleErrors]="pinConfirmationErrors"
          ></app-input>
        </div>
      </div>
      <div class="section-title">eSignature Communication Preferences</div>
      <div class="pt-4">
        <div>Please select your email preferences below.</div>
        <div class="h-4">
          <mat-error *ngIf="formGroup.hasError('at-least-one-send')">
            Please select one more Communication Preference check box to
            continue.
          </mat-error>
        </div>
        <div class="flex flex-col gap-3 mt-4">
          <div>
            <mat-checkbox formControlName="isSendEverySignatureRequest">
              Send with every signature request
            </mat-checkbox>
          </div>
          <div class="flex gap-2">
            <mat-checkbox
              class="w-1/5 mr-2"
              formControlName="isSendEveryDay"
              (change)="
                updateEveryDayControlStatus($event.checked)
              "
            >
              Send summary every day at
            </mat-checkbox>
            <thera-dropdown
              class="w-24"
              [options]="hours"
              [required]="!!formGroup.get('isSendEveryDay')?.value"
              [formGroup]="formGroup"
              controlName="sendEveryDayTime"
            ></thera-dropdown>
            <thera-dropdown
              class="w-20"
              [options]="meridians"
              [required]="!!formGroup.get('isSendEveryDay')?.value"
              [formGroup]="formGroup"
              controlName="sendEveryDayMeridian"
            ></thera-dropdown>
          </div>
          <div class="h-4">
            <mat-error *ngIf="formGroup.hasError('isEveryDayValidate')">
              Please select the time dropdown menus to continue.
            </mat-error>
          </div>
          <div class="flex gap-2">
            <mat-checkbox
              class="w-1/5 mr-2"
              formControlName="isSendEveryWeek"
              (change)="
                updateEveryWeekControlStatus($event.checked)
              "
            >
              Send summary every week at
            </mat-checkbox>
            <thera-dropdown
              class="w-24"
              [options]="hours"
              [required]="!!formGroup.get('isSendEveryWeek')?.value"
              [formGroup]="formGroup"
              controlName="sendEveryWeekTime"
            ></thera-dropdown>
            <thera-dropdown
              class="w-20"
              [options]="meridians"
              [required]="!!formGroup.get('isSendEveryWeek')?.value"
              [formGroup]="formGroup"
              controlName="sendEveryWeekMeridian"
            ></thera-dropdown>
            <thera-dropdown
              class="w-40"
              [options]="days"
              [required]="!!formGroup.get('isSendEveryWeek')?.value"
              [formGroup]="formGroup"
              controlName="sendEveryWeekDay"
            ></thera-dropdown>
          </div>
        </div>
        <div class="h-4">
          <mat-error *ngIf="formGroup.hasError('isEveryWeekValidate')">
            Please select the time and date dropdown menus to continue.
          </mat-error>
        </div>
        <div class="h-4">
        </div>
      </div>
    </form>
  </ng-container>
